import {Component, Input} from '@angular/core';
import {UserComponentObject} from '../../classes/user-component-object';

@Component({
  selector: 'app-user-badge',
  templateUrl: './user-badge.component.html',
  styleUrls: ['./user-badge.component.scss']
})
export class UserBadgeComponent {
  @Input() public user: UserComponentObject;
}
